import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FileBasedImportInventoryContainerComponent } from './file-based-import-inventory-container.component';

@Injectable({
  providedIn: 'root'
})
export class FileBasedImportInventoryDialogService {
  private matDialog = inject(MatDialog);


  openFileBasedImportInventoryDialog(): MatDialogRef<FileBasedImportInventoryContainerComponent> {
    return this.matDialog.open(FileBasedImportInventoryContainerComponent, {
      width: '30%',
      autoFocus: false,
      disableClose: true
    });
  }
}
